
import Promise from "plugins/bluebird"

import {
  requestIdleCallback,
  RequestIdleCallbackPayload,
} from "plugins/request-animation-frame-polyfill"

import tracking from "./tracking/index"
import {Page} from "app/multi_device"

const onLoad = (): void => {
  tracking.init()

  if (Page.isForDesktop()){
    Promise.resolve(
      import("./desktop/onLoad")
    )
    .then(({default: Desktop}) => {
      Desktop.onLoad()
    })
  }
  if (Page.isForMobile()){
    Promise.resolve(
      import("./mobile/onLoad")
    )
    .then(({default: Mobile}) => {
      Mobile.onLoad()
    })
  }

  function init_tutorial_save_search(deadline: RequestIdleCallbackPayload) {
    if (deadline.timeRemaining() <= 0 && !deadline.didTimeout) {
      // Reschedule
      requestIdleCallback(init_tutorial_save_search)
      return
    }

    Promise.resolve(
      import("./tutorial_save_search/index")
    )
    .then(({default: tutorial_save_search}) => {
      requestIdleCallback(() => {
        tutorial_save_search.onLoad()
      })
    })
  }
  requestIdleCallback(init_tutorial_save_search)
}

export default {onLoad}
